import arBase from "./ar.json";
import apiErrors from "./api-errors.ar.json";
import travelersInfo from "@/features/travelers-info/locales/ar.json";
import passportInfo from "@/features/passport-info/locales/ar.json";
import quoteList from "@/features/quote-list/locales/ar.json";
import policySummary from "@/features/policy-summary/locales/ar.json";
import postPayment from "@/features/post-payment/locales/ar.json";
import common from "./common.ar.json";
import iban from "@/features/iban/locales/ar.json";
import receipt from "@/features/receipt/locales/ar.json";

export default {
  ...arBase,
  apiErrors,
  travelersInfo,
  passportInfo,
  quoteList,
  policySummary,
  postPayment,
  common,
  iban,
  receipt,
} as const;
